/** Tracks the current mouse hover position on the calendar grid */

interface HoverPosition {
  readonly date: string;
  readonly time: string;
}

let current: HoverPosition | null = null;

export function setHoverPosition(pos: HoverPosition | null) {
  current = pos;
}

export function getHoverPosition(): HoverPosition | null {
  return current;
}
